import styled from "styled-components";

export const ThreeBox = styled.section`
  height: calc(35vh);
  min-height: 200px;
  width: 100%;
`;
